import React, { useState, useEffect } from 'react';
import { Star, Heart, Eye, Award, Shield, Zap, Droplets } from 'lucide-react';
import carefinLogo from './Carefin_page-0001.jpg';
import violetNapkin from './Napkin/carefine-book-volet.jpg';
import orangeNapkin from './Napkin/carefine-book-orang.jpg';
import greenNapkin from './Napkin/carefine-book-green.jpg';
import emaraldNapkin from './Napkin/carefine-book-emarald.jpg';
import blueNapkin from './Napkin/carefine-book-blue.jpg';
import certificationImage from './cirtifications.png';
import logoWay from './logo way.jpg';
import brandConceptCenterImage from './BrandConcept.jpg';

export default function CarefinPage() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  // const [likedProducts, setLikedProducts] = useState(new Set());

  // const products = [
  //   {
  //     id: 'sanitary-napkins',
  //     name: 'Sanitary Napkins',
  //     category: 'FEMININE CARE',
  //     description: 'Premium sanitary napkins for maximum comfort and protection',
  //     features: [
  //       { title: 'Superior Absorbency', description: 'Advanced technology for maximum protection', color: 'pink', icon: Shield },
  //       { title: 'Breathable Material', description: 'Comfortable and skin-friendly', color: 'purple', icon: Heart },
  //       { title: 'Comfortable Fit', description: 'Designed for all-day comfort', color: 'green', icon: Award },
  //       { title: 'Hypoallergenic', description: 'Safe for sensitive skin', color: 'blue', icon: Zap }
  //     ],
  //     sizes: [
  //       { size: 'Regular', type: 'Daily Use', color: 'pink', price: '₹120' },
  //       { size: 'Super', type: 'Heavy Flow', color: 'purple', price: '₹150', popular: true },
  //       { size: 'Night', type: 'Overnight', color: 'green', price: '₹180' }
  //     ],
  //     ingredients: [
  //       'Cotton',
  //       'Polyester',
  //       'Super Absorbent Polymer',
  //       'Adhesive',
  //       'Non-woven Fabric',
  //       'Release Paper'
  //     ],
  //     gradient: 'from-pink-50 via-white to-purple-50/30',
  //     badgeColor: 'pink',
  //     primaryColor: 'pink',
  //     secondaryColor: 'purple',
  //     rating: 4.8,
  //     reviews: 1247
  //   },
  //   {
  //     id: 'luxury-perfumes',
  //     name: 'Luxury Perfumes',
  //     category: 'LUXURY FRAGRANCES',
  //     description: 'Exquisite fragrances crafted with premium ingredients',
  //     features: [
  //       { title: 'Premium Ingredients', description: 'High-quality essential oils and extracts', color: 'purple', icon: Star },
  //       { title: 'Long-lasting Fragrance', description: 'Scent that lingers throughout the day', color: 'pink', icon: Heart },
  //       { title: 'Elegant Packaging', description: 'Sophisticated and luxurious design', color: 'green', icon: Award },
  //       { title: 'Unique Scent Profiles', description: 'Distinctive and memorable fragrances', color: 'blue', icon: Zap }
  //     ],
  //     sizes: [
  //       { size: '30ml', type: 'Travel Size', color: 'purple', price: '₹450' },
  //       { size: '50ml', type: 'Regular Size', color: 'pink', price: '₹750', popular: true },
  //       { size: '100ml', type: 'Large Size', color: 'green', price: '₹1200' }
  //     ],
  //     gradient: 'from-purple-50 via-white to-pink-50/30',
  //     badgeColor: 'purple',
  //     primaryColor: 'purple',
  //     secondaryColor: 'pink',
  //     rating: 4.7,
  //     reviews: 892
  //   }
  // ];

  // const getColorClasses = (color) => {
  //   const colors = {
  //     orange: { bg: 'bg-orange-100', border: 'border-orange-200', text: 'text-orange-900', badge: 'bg-orange-100', badgeText: 'text-orange-800' },
  //     blue: { bg: 'bg-blue-100', border: 'border-blue-200', text: 'text-blue-900', badge: 'bg-blue-100', badgeText: 'text-blue-800' },
  //     green: { bg: 'bg-green-100', border: 'border-green-200', text: 'text-green-900', badge: 'bg-green-100', badgeText: 'text-green-800' },
  //     purple: { bg: 'bg-purple-100', border: 'border-purple-200', text: 'text-purple-900', badge: 'bg-purple-100', badgeText: 'text-purple-800' },
  //     pink: { bg: 'bg-pink-100', border: 'border-pink-200', text: 'text-pink-900', badge: 'bg-pink-100', badgeText: 'text-pink-800' }
  //   };
  //   return colors[color] || colors.blue;
  // };

  // const toggleLike = (productId) => {
  //   const newLikedProducts = new Set(likedProducts);
  //   if (newLikedProducts.has(productId)) {
  //     newLikedProducts.delete(productId);
  //   } else {
  //     newLikedProducts.add(productId);
  //   }
  //   setLikedProducts(newLikedProducts);
  // };

  // const renderStars = (rating) => {
  //   return Array.from({ length: 5 }, (_, i) => (
  //     <Star
  //       key={i}
  //       className={`w-3 h-3 ${i < Math.floor(rating) ? 'text-yellow-400 fill-current' : 'text-gray-300'}`}
  //     />
  //   ));
  // };

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white py-12">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-pink-50 via-white to-purple-50/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            
            {/* Left column - Description */}
            <div className="w-full lg:w-1/2 text-left space-y-8">
              
              {/* Main heading */}
              <div className="space-y-6">
                <h1 className="text-5xl sm:text-6xl font-bold text-gray-900 leading-tight">
                  <span className="text-pink-600">CAREFIN</span>
                </h1>
                
                <div className="w-32 h-1 bg-gradient-to-r from-pink-600 to-purple-500 rounded-full"></div>
                
                <p className="text-xl font-light text-gray-600 leading-relaxed max-w-xl">
                  Premium <span className="font-semibold text-pink-900">Feminine Care</span> and <span className="font-semibold text-purple-900">Luxury Fragrances</span> for modern women.
                </p>
              </div>

              {/* Description */}
              <div className="space-y-6 max-w-xl">
                <p className="text-lg text-gray-600 leading-relaxed">
                  Experience the elegance of premium feminine care with Carefin. Our products combine advanced technology with luxurious comfort to deliver exceptional protection and sophisticated fragrances for the modern woman .
                </p>
                
                {/* Key benefits */}
                <div className="grid grid-cols-2 gap-6 pt-6">
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-pink-100 rounded-full flex items-center justify-center">
                      <Heart className="w-4 h-4 text-pink-600" />
                    </div>
                    <span className="text-base font-medium text-gray-700">Premium Care</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                      <Star className="w-4 h-4 text-purple-600" />
                    </div>
                    <span className="text-base font-medium text-gray-700">Luxury Fragrances</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                      <Shield className="w-4 h-4 text-green-600" />
                    </div>
                    <span className="text-base font-medium text-gray-700">Quality & Safety</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                      <Award className="w-4 h-4 text-blue-600" />
                    </div>
                    <span className="text-base font-medium text-gray-700">Premium Experience</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right column - Carefin Image */}
            <div className="w-full lg:w-1/2 relative flex items-center justify-center">
              <div className="relative w-full max-w-md">
                <div className="bg-white rounded-2xl p-8 ">
                  <img 
                    src={carefinLogo} 
                    alt="Carefin Logo" 
                    className="w-full h-full object-contain"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="hidden items-center justify-center h-full w-full">
                    <span className="text-xl font-bold text-gray-700 text-center">Carefin Logo</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 via-white to-pink-50/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-left mb-20">
            <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-pink-100 to-purple-100 px-4 py-2 rounded-full mb-8">
              <div className="w-2 h-2 bg-pink-500 rounded-full"></div>
              <span className="text-sm font-semibold text-pink-700">Our Journey</span>
            </div>
            <h2 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-8 leading-tight">
              Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600">Story</span>
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full mb-10"></div>
            <p className="text-xl text-gray-600 max-w-7xl leading-relaxed">
            We are a Canadian born hygiene and personal care brand, fully focused on delivering high quality hygiene products. Now we are venturing our way to nation, which rich in culture and traditions. We bring you the quality and technologies from Canadian experts, for affordable and safer hygiene products. We believe in quality over anything, to provide the psychological relief for not to be worried about leakage. That's why we give more concentration on our customers feedbacks and expiriment with new ideas.
            </p>
          </div>

          {/* Main Content Grid */}
          <div className="grid xl:grid-cols-2 gap-12 mb-24">
            {/* Why Carefin */}
            <div className="relative">
              <div className="bg-white rounded-2xl p-8 border border-gray-200 h-full flex flex-col">
                <div className="flex items-center space-x-4 mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-pink-500 to-purple-500 rounded-xl flex items-center justify-center">
                    <Star className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">Why Carefin</h3>
                </div>
                <div className="space-y-4 flex-grow">
                  <p className="text-gray-600 font-medium text-base">
                    What makes us different from other brands? Why you should buy our products?
                  </p>
                  <p className="text-gray-700 leading-relaxed text-base">
                    Our sanitary napkins are carefully crafted with infinite layers of happiness, care, safety and hygiene.
                  </p>
                  <div className="flex items-center space-x-2 pt-4 mt-auto">
                    <div className="flex space-x-1">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" />
                      ))}
                    </div>
                    <span className="text-sm text-gray-500 font-medium">Premium Quality</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Corporate Social Responsibility */}
            <div className="relative">
              <div className="bg-white rounded-2xl p-8 border border-gray-200 h-full flex flex-col">
                <div className="flex items-center space-x-4 mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center">
                    <Heart className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">Corporate Social Responsibility</h3>
                </div>
                <div className="space-y-4 flex-grow">
                 
                  <p className="text-gray-700 leading-relaxed text-base">
                We believe that women's hygiene is essential for empowering women. And India is far behind in women's hygiene; it is all because even today only 30% of women in India are using sanitary napkins, the other 50% use cloth, and 20% use locally prepared napkins.
So we are planning to provide sanitary napkins to underprivileged tribal women across the nation.
We started this movement from a tribal area in Wayanad. When we approached them for the first time they were so afraid about the products because they hadn't heard and didn't have any knowledge about this. But we explained to them why this was important and how it could improve their lives. Now, they are some of our biggest advocates!
This event was a huge inspiration and motivation for our employees and for us to work hard for empowering women.

                  </p>
                  <p className="text-gray-700 leading-relaxed text-base">
                    So we are planning to provide sanitary napkins to underprivileged tribal women across the nation.
                    We started this movement from a tribal area in Wayanad. When we approached them for the first time they were so afraid about the products because they hadn't heard and didn't have any knowledge about this. But we explained to them why this was important and how it could improve their lives. Now, they are some of our biggest advocates!
This event was a huge inspiration and motivation for our employees and for us to work hard for empowering women.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Success Story */}
          {/* <div className="mb-24">
            <div className="bg-gradient-to-br from-pink-50 via-white to-purple-50 rounded-3xl p-16">
              <div className="text-left mb-12">
                <div className="inline-flex items-center space-x-2 bg-white px-6 py-3 rounded-full mb-6">
                  <Award className="w-6 h-6 text-pink-600" />
                  <span className="text-base font-semibold text-pink-700">Success Story</span>
                </div>
                <h3 className="text-4xl font-bold text-gray-900 mb-6">Our Success Story</h3>
                <div className="w-24 h-1 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full mb-8"></div>
              </div>
              <div className="max-w-4xl">
                <div className="space-y-8">
                  <p className="text-xl text-gray-700 leading-relaxed">
                    We started this movement from a tribal area in Wayanad. When we approached them for the first time they were so afraid about the products because they hadn't heard and didn't have any knowledge about this.
                  </p>
                  <p className="text-xl text-gray-700 leading-relaxed">
                    But we explained to them why this was important and how it could improve their lives. Now, they are some of our biggest advocates!
                  </p>
                </div>
              </div>
            </div>
          </div> */}

          {/* Mission & Vision */}
          <div className="grid xl:grid-cols-2 gap-12">
            {/* Mission */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 h-full flex flex-col">
              <div className="flex items-center space-x-4 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-blue-500 rounded-xl flex items-center justify-center">
                  <Shield className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Mission</h3>
              </div>
              <div className="flex-grow">
                <p className="text-gray-700 leading-relaxed text-base">
                  To provide a clean and uncomplicated period wellness to all the butterflies, and providing them with a comfort to fly with No barriers to hold them back.
                </p>
                <div className="mt-6 flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  <span className="text-sm text-gray-500 font-medium">Empowering Women</span>
                </div>
              </div>
            </div>

            {/* Vision */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 h-full flex flex-col">
              <div className="flex items-center space-x-4 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-500 rounded-xl flex items-center justify-center">
                  <Eye className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Vision</h3>
              </div>
              <div className="flex-grow">
                <p className="text-gray-700 leading-relaxed text-base">
                  To create an awareness among the people about periods. Making this world an open space where anyone could openly speak about periods and period hygiene.
                </p>
                <div className="mt-6 flex items-center space-x-2">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span className="text-sm text-gray-500 font-medium">Creating Awareness</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Brand Concept Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 via-white to-pink-50/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-left mb-20">
            <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-pink-100 to-purple-100 px-4 py-2 rounded-full mb-6">
              <div className="w-2 h-2 bg-pink-500 rounded-full"></div>
              <span className="text-sm font-semibold text-pink-700">Brand Philosophy</span>
            </div>
            <h2 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-8">
              Brand <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600">Concept</span> for Carefin
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full mb-10"></div>
            <p className="text-xl text-gray-600 max-w-4xl leading-relaxed">
              Our brand concept revolves around empowering women through premium feminine care products that combine advanced technology with luxurious comfort.
            </p>
          </div>

          {/* Brand Concept Content */}
      

          {/* Center Brand Concept Image */}
          <div className="flex justify-center my-16">
            <div className="relative w-full max-w-4xl">
              <div className="bg-white rounded-3xl p-8 shadow-lg">
                <img 
                  src={brandConceptCenterImage} 
                  alt="Carefin Brand Concept" 
                  className="w-full h-auto object-contain rounded-2xl"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="hidden items-center justify-center h-64 w-full">
                  <span className="text-xl font-bold text-gray-700 text-center">Carefin Brand Concept</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Logo Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 via-white to-pink-50/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-left mb-20">
            <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-pink-100 to-purple-100 px-4 py-2 rounded-full mb-6">
              <div className="w-2 h-2 bg-pink-500 rounded-full"></div>
              <span className="text-sm font-semibold text-pink-700">Our Brand</span>
            </div>
            <h2 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-8">
              Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600">Logo</span>
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full mb-10"></div>
            <p className="text-xl text-gray-600 max-w-4xl leading-relaxed">
              Discover the story behind our logo and what it represents for the Carefin brand.
            </p>
          </div>

          {/* Logo Display */}
          <div className="flex justify-center">
            <div className="bg-white rounded-3xl max-w-4xl">
              <div className="p-8">
                <div className="flex justify-center">
                  <div className="relative w-full max-w-3xl">
                    <div className="rounded-2xl p-8">
                      <img 
                        src={logoWay} 
                        alt="Carefin Logo Way" 
                        className="w-full h-auto object-contain rounded-xl"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                      <div className="hidden items-center justify-center h-64 w-full">
                        <span className="text-xl font-bold text-gray-700 text-center">Carefin Logo Way</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 via-white to-pink-50/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-left mb-20">
            <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-pink-100 to-purple-100 px-4 py-2 rounded-full mb-6">
              <div className="w-2 h-2 bg-pink-500 rounded-full"></div>
              <span className="text-sm font-semibold text-pink-700">Premium Collection</span>
            </div>
            <h2 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-8">
              Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600">Products</span>
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full mb-10"></div>
            <p className="text-xl text-gray-600 max-w-4xl leading-relaxed">
              Discover the advanced technology and premium ingredients that make Carefin the perfect choice for feminine care and luxury fragrances
            </p>
          </div>

          {/* Product Cards */}
          <div className="space-y-24">
            
            {/* Carefin Ultra-Thin 280mm 7 Pads - Orange */}
            <div className="relative">
              <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden">
                <div className="grid xl:grid-cols-2 min-h-[600px]">
                  
                  {/* Left Side - Content */}
                  <div className="p-12 flex flex-col justify-center">
                    <div className="space-y-8">
                      {/* Product Badge */}
                      <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-orange-100 to-red-100 px-4 py-2 rounded-full">
                        <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                        <span className="text-sm font-semibold text-orange-700">ULTRA-THIN</span>
                      </div>
                      
                      {/* Product Title */}
                      <div>
                        <h3 className="text-4xl font-bold text-gray-900 mb-4">Carefin Ultra-Thin 280mm</h3>
                        <p className="text-lg text-gray-600 leading-relaxed">
                          Premium ultra-thin sanitary napkins with 7 pads per pack. Designed for maximum comfort and protection with advanced absorbency technology.
                        </p>
                      </div>

                      {/* Product Details Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="text-center p-4 bg-gradient-to-br from-orange-50 to-red-50 rounded-xl">
                          <span className="text-2xl font-bold text-orange-600 block">7 Pads</span>
                          <span className="text-sm text-gray-500">Per Pack</span>
                        </div>
                        <div className="text-center p-4 bg-gradient-to-br from-red-50 to-orange-50 rounded-xl">
                          <span className="text-2xl font-bold text-red-600 block">280mm</span>
                          <span className="text-sm text-gray-500">Length</span>
                        </div>
                      </div>

                      {/* Specifications */}
                      <div className="space-y-4">
                        <h4 className="text-lg font-semibold text-gray-800">Product Specifications</h4>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-600">Absorbency:</span>
                            <span className="font-medium">Medium Flow</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Thickness:</span>
                            <span className="font-medium">Ultra-Thin</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Wings:</span>
                            <span className="font-medium">With Wings</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Pack Size:</span>
                            <span className="font-medium">7 Pads</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Length:</span>
                            <span className="font-medium">280mm</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Width:</span>
                            <span className="font-medium">75mm</span>
                          </div>
                        </div>
                      </div>

                      {/* Features Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Ultra-Thin Design</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Superior Absorbency</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Breathable Material</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Wings for Secure Fit</span>
                        </div>
                      </div>

                      {/* Materials */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Premium Materials</h4>
                        <p className="text-sm text-gray-600">
                          Cotton, Polyester, Super Absorbent Polymer, Adhesive, Non-woven Fabric, Release Paper
                        </p>
                      </div>

                      {/* Key Benefits */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Key Benefits</h4>
                        <ul className="text-sm text-gray-600 space-y-2">
                          <li className="flex items-start space-x-2">
                            <span className="text-orange-500 mt-1">•</span>
                            <span>Advanced absorbency technology for maximum protection</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-orange-500 mt-1">•</span>
                            <span>Breathable top layer for comfort throughout the day</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-orange-500 mt-1">•</span>
                            <span>Secure wings prevent leakage and provide confident fit</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-orange-500 mt-1">•</span>
                            <span>Hypoallergenic material safe for sensitive skin</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Image */}
                  <div className="bg-gradient-to-br from-orange-50 via-white to-red-50 flex items-center justify-center p-12">
                    <div className="relative w-full max-w-md">
                      <div className="bg-white rounded-2xl p-8 ">
                        <img 
                          src={orangeNapkin} 
                          alt="Carefin Ultra-Thin 280mm 7 Pads" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Carefin Ultra-Thin 330mm 7 Pads - Violet */}
            <div className="relative">
              <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden">
                <div className="grid xl:grid-cols-2 min-h-[600px]">
                  
                  {/* Left Side - Image */}
                  <div className="bg-gradient-to-br from-purple-50 via-white to-pink-50 flex items-center justify-center p-12">
                    <div className="relative w-full max-w-md">
                      <div className="bg-white rounded-2xl p-8 ">
                        <img 
                          src={violetNapkin} 
                          alt="Carefin Ultra-Thin 330mm 7 Pads" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Content */}
                  <div className="p-12 flex flex-col justify-center">
                    <div className="space-y-8">
                      {/* Product Badge */}
                      <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-purple-100 to-pink-100 px-4 py-2 rounded-full">
                        <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                        <span className="text-sm font-semibold text-purple-700">ULTRA-THIN</span>
                      </div>
                      
                      {/* Product Title */}
                      <div>
                        <h3 className="text-4xl font-bold text-gray-900 mb-4">Carefin Ultra-Thin 330mm</h3>
                        <p className="text-lg text-gray-600 leading-relaxed">
                          Premium ultra-thin sanitary napkins with 7 pads per pack. Extended length for maximum coverage and protection during heavy flow days.
                        </p>
                      </div>

                      {/* Product Details Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="text-center p-4 bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl">
                          <span className="text-2xl font-bold text-purple-600 block">7 Pads</span>
                          <span className="text-sm text-gray-500">Per Pack</span>
                        </div>
                        <div className="text-center p-4 bg-gradient-to-br from-pink-50 to-purple-50 rounded-xl">
                          <span className="text-2xl font-bold text-pink-600 block">330mm</span>
                          <span className="text-sm text-gray-500">Length</span>
                        </div>
                      </div>

                      {/* Specifications */}
                      <div className="space-y-4">
                        <h4 className="text-lg font-semibold text-gray-800">Product Specifications</h4>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-600">Absorbency:</span>
                            <span className="font-medium">Heavy Flow</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Thickness:</span>
                            <span className="font-medium">Ultra-Thin</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Wings:</span>
                            <span className="font-medium">With Wings</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Pack Size:</span>
                            <span className="font-medium">7 Pads</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Length:</span>
                            <span className="font-medium">330mm</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Width:</span>
                            <span className="font-medium">75mm</span>
                          </div>
                        </div>
                      </div>

                      {/* Features Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Extended Length</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-pink-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Heavy Flow Protection</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Ultra-Thin Design</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Secure Wings</span>
                        </div>
                      </div>

                      {/* Materials */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Premium Materials</h4>
                        <p className="text-sm text-gray-600">
                          Cotton, Polyester, Super Absorbent Polymer, Adhesive, Non-woven Fabric, Release Paper
                        </p>
                      </div>

                      {/* Key Benefits */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Key Benefits</h4>
                        <ul className="text-sm text-gray-600 space-y-2">
                          <li className="flex items-start space-x-2">
                            <span className="text-purple-500 mt-1">•</span>
                            <span>Extended length for maximum coverage and protection</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-purple-500 mt-1">•</span>
                            <span>Enhanced absorbency for heavy flow days</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-purple-500 mt-1">•</span>
                            <span>Secure wings prevent side leakage</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-purple-500 mt-1">•</span>
                            <span>Comfortable fit for overnight protection</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Carefin Ultra-Thin 280mm 4 Pads - Emerald */}
            <div className="relative">
              <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden">
                <div className="grid xl:grid-cols-2 min-h-[600px]">
                  
                  {/* Left Side - Content */}
                  <div className="p-12 flex flex-col justify-center">
                    <div className="space-y-8">
                      {/* Product Badge */}
                      <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-emerald-100 to-teal-100 px-4 py-2 rounded-full">
                        <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
                        <span className="text-sm font-semibold text-emerald-700">ULTRA-THIN</span>
                      </div>
                      
                      {/* Product Title */}
                      <div>
                        <h3 className="text-4xl font-bold text-gray-900 mb-4">Carefin Ultra-Thin 280mm</h3>
                        <p className="text-lg text-gray-600 leading-relaxed">
                          Premium ultra-thin sanitary napkins with 4 pads per pack. Compact pack perfect for travel and light flow days.
                        </p>
                      </div>

                      {/* Product Details Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="text-center p-4 bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl">
                          <span className="text-2xl font-bold text-emerald-600 block">14 Pads</span>
                          <span className="text-sm text-gray-500">Per Pack</span>
                        </div>
                        <div className="text-center p-4 bg-gradient-to-br from-teal-50 to-emerald-50 rounded-xl">
                          <span className="text-2xl font-bold text-teal-600 block">280mm</span>
                          <span className="text-sm text-gray-500">Length</span>
                        </div>
                      </div>

                      {/* Specifications */}
                      <div className="space-y-4">
                        <h4 className="text-lg font-semibold text-gray-800">Product Specifications</h4>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-600">Absorbency:</span>
                            <span className="font-medium">Light Flow</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Thickness:</span>
                            <span className="font-medium">Ultra-Thin</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Wings:</span>
                            <span className="font-medium">With Wings</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Pack Size:</span>
                            <span className="font-medium">4 Pads</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Length:</span>
                            <span className="font-medium">280mm</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Width:</span>
                            <span className="font-medium">75mm</span>
                          </div>
                        </div>
                      </div>

                      {/* Features Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-emerald-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Travel Friendly</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-teal-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Light Flow Protection</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Ultra-Thin Design</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-pink-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Compact Pack</span>
                        </div>
                      </div>

                      {/* Materials */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Premium Materials</h4>
                        <p className="text-sm text-gray-600">
                          Cotton, Polyester, Super Absorbent Polymer, Adhesive, Non-woven Fabric, Release Paper
                        </p>
                      </div>

                      {/* Key Benefits */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Key Benefits</h4>
                        <ul className="text-sm text-gray-600 space-y-2">
                          <li className="flex items-start space-x-2">
                            <span className="text-emerald-500 mt-1">•</span>
                            <span>Compact pack perfect for travel and on-the-go use</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-emerald-500 mt-1">•</span>
                            <span>Ideal for light flow days and daily protection</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-emerald-500 mt-1">•</span>
                            <span>Discrete packaging for privacy</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-emerald-500 mt-1">•</span>
                            <span>Same premium quality in smaller pack</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Image */}
                  <div className="bg-gradient-to-br from-emerald-50 via-white to-teal-50 flex items-center justify-center p-12">
                    <div className="relative w-full max-w-md">
                      <div className="bg-white rounded-2xl p-8 ">
                        <img 
                          src={emaraldNapkin} 
                          alt="Carefin Ultra-Thin 280mm 4 Pads" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Carefin Ultra-Thin 330mm 4 Pads - Green */}
            <div className="relative">
              <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden">
                <div className="grid xl:grid-cols-2 min-h-[600px]">
                  
                  {/* Left Side - Image */}
                  <div className="bg-gradient-to-br from-green-50 via-white to-blue-50 flex items-center justify-center p-12">
                    <div className="relative w-full max-w-md">
                      <div className="bg-white rounded-2xl p-8 ">
                        <img 
                          src={greenNapkin} 
                          alt="Carefin Ultra-Thin 330mm 4 Pads" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Content */}
                  <div className="p-12 flex flex-col justify-center">
                    <div className="space-y-8">
                      {/* Product Badge */}
                      <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-green-100 to-blue-100 px-4 py-2 rounded-full">
                        <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                        <span className="text-sm font-semibold text-green-700">ULTRA-THIN</span>
                      </div>
                      
                      {/* Product Title */}
                      <div>
                        <h3 className="text-4xl font-bold text-gray-900 mb-4">Carefin Ultra-Thin 330mm</h3>
                        <p className="text-lg text-gray-600 leading-relaxed">
                          Premium ultra-thin sanitary napkins with 4 pads per pack. Extended length with compact pack size for maximum coverage and convenience.
                        </p>
                      </div>

                      {/* Product Details Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="text-center p-4 bg-gradient-to-br from-green-50 to-blue-50 rounded-xl">
                          <span className="text-2xl font-bold text-green-600 block">14 Pads</span>
                          <span className="text-sm text-gray-500">Per Pack</span>
                        </div>
                        <div className="text-center p-4 bg-gradient-to-br from-blue-50 to-green-50 rounded-xl">
                          <span className="text-2xl font-bold text-blue-600 block">330mm</span>
                          <span className="text-sm text-gray-500">Length</span>
                        </div>
                      </div>

                      {/* Specifications */}
                      <div className="space-y-4">
                        <h4 className="text-lg font-semibold text-gray-800">Product Specifications</h4>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-600">Absorbency:</span>
                            <span className="font-medium">Medium-Heavy Flow</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Thickness:</span>
                            <span className="font-medium">Ultra-Thin</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Wings:</span>
                            <span className="font-medium">With Wings</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Pack Size:</span>
                            <span className="font-medium">4 Pads</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Length:</span>
                            <span className="font-medium">330mm</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Width:</span>
                            <span className="font-medium">75mm</span>
                          </div>
                        </div>
                      </div>

                      {/* Features Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Extended Length</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Compact Pack</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Ultra-Thin Design</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-pink-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Travel Friendly</span>
                        </div>
                      </div>

                      {/* Materials */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Premium Materials</h4>
                        <p className="text-sm text-gray-600">
                          Cotton, Polyester, Super Absorbent Polymer, Adhesive, Non-woven Fabric, Release Paper
                        </p>
                      </div>

                      {/* Key Benefits */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Key Benefits</h4>
                        <ul className="text-sm text-gray-600 space-y-2">
                          <li className="flex items-start space-x-2">
                            <span className="text-green-500 mt-1">•</span>
                            <span>Extended length coverage with compact pack size</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-green-500 mt-1">•</span>
                            <span>Perfect balance of protection and convenience</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-green-500 mt-1">•</span>
                            <span>Ideal for travel and on-the-go protection</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-green-500 mt-1">•</span>
                            <span>Enhanced absorbency for medium to heavy flow</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Carefin Ultra-Thin 280mm 40 Pads - Blue */}
            <div className="relative">
              <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden">
                <div className="grid xl:grid-cols-2 min-h-[600px]">
                  
                  {/* Left Side - Content */}
                  <div className="p-12 flex flex-col justify-center">
                    <div className="space-y-8">
                      {/* Product Badge */}
                      <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-blue-100 to-indigo-100 px-4 py-2 rounded-full">
                        <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                        <span className="text-sm font-semibold text-blue-700">FAMILY PACK</span>
                      </div>
                      
                      {/* Product Title */}
                      <div>
                        <h3 className="text-4xl font-bold text-gray-900 mb-4">Carefin Ultra-Thin 280mm</h3>
                        <p className="text-lg text-gray-600 leading-relaxed">
                          Premium ultra-thin sanitary napkins with 40 pads per pack. Family size pack for extended use with maximum value and convenience.
                        </p>
                      </div>

                      {/* Product Details Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="text-center p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl">
                          <span className="text-2xl font-bold text-blue-600 block">40 Pads</span>
                          <span className="text-sm text-gray-500">Per Pack</span>
                        </div>
                        <div className="text-center p-4 bg-gradient-to-br from-indigo-50 to-blue-50 rounded-xl">
                          <span className="text-2xl font-bold text-indigo-600 block">280mm</span>
                          <span className="text-sm text-gray-500">Length</span>
                        </div>
                      </div>

                      {/* Specifications */}
                      <div className="space-y-4">
                        <h4 className="text-lg font-semibold text-gray-800">Product Specifications</h4>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-600">Absorbency:</span>
                            <span className="font-medium">Medium Flow</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Thickness:</span>
                            <span className="font-medium">Ultra-Thin</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Wings:</span>
                            <span className="font-medium">With Wings</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Pack Size:</span>
                            <span className="font-medium">40 Pads</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Length:</span>
                            <span className="font-medium">280mm</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Width:</span>
                            <span className="font-medium">75mm</span>
                          </div>
                        </div>
                      </div>

                      {/* Features Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Family Size Pack</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-indigo-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Maximum Value</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Ultra-Thin Design</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-pink-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Extended Use</span>
                        </div>
                      </div>

                      {/* Materials */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Premium Materials</h4>
                        <p className="text-sm text-gray-600">
                          Cotton, Polyester, Super Absorbent Polymer, Adhesive, Non-woven Fabric, Release Paper
                        </p>
                      </div>

                      {/* Key Benefits */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Key Benefits</h4>
                        <ul className="text-sm text-gray-600 space-y-2">
                          <li className="flex items-start space-x-2">
                            <span className="text-blue-500 mt-1">•</span>
                            <span>Family size pack for extended use and maximum value</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-blue-500 mt-1">•</span>
                            <span>Cost-effective solution for regular use</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-blue-500 mt-1">•</span>
                            <span>Same premium quality in bulk quantity</span>
                          </li>
                          <li className="flex items-start space-x-2">
                            <span className="text-blue-500 mt-1">•</span>
                            <span>Perfect for household and family use</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Image */}
                  <div className="bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex items-center justify-center p-12">
                    <div className="relative w-full max-w-md">
                      <div className="bg-white rounded-2xl p-8 ">
                        <img 
                          src={blueNapkin} 
                          alt="Carefin Ultra-Thin 280mm 40 Pads" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 via-white to-pink-50/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-left mb-20">
            <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-pink-100 to-purple-100 px-4 py-2 rounded-full mb-6">
              <div className="w-2 h-2 bg-pink-500 rounded-full"></div>
              <span className="text-sm font-semibold text-pink-700">Quality Assurance</span>
            </div>
            <h2 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-8">
              Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600">Certifications</span>
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full mb-10"></div>
            <p className="text-xl text-gray-600 max-w-4xl leading-relaxed">
              Carefin products meet the highest standards of quality and safety. Our certifications ensure that every product is manufactured with the utmost care and attention to detail.
            </p>
          </div>

          {/* Certification Display */}
          <div className="flex justify-center">
            <div className="bg-white  border-gray-200 overflow-hidden  max-w-4xl">
              <div className="p-8">

                
                <div className="flex justify-center">
                  <div className="relative w-full max-w-3xl">
                    <div className="bg-gradient-to-br from-pink-50 via-white to-purple-50 rounded-2xl p-8">
                      <img 
                        src={certificationImage} 
                        alt="Carefin Certifications" 
                        className="w-full h-auto object-contain rounded-xl"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                      <div className="hidden items-center justify-center h-64 w-full">
                        <span className="text-xl font-bold text-gray-700 text-center">Carefin Certifications</span>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-lg w-full max-h-[80vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-lg font-bold text-gray-900">{selectedProduct.name}</h3>
                <button 
                  onClick={() => setSelectedProduct(null)}
                  className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                >
                  <span className="text-xl">×</span>
                </button>
              </div>
              
              <div className="space-y-4">
                <p className="text-sm text-gray-600">{selectedProduct.longDescription}</p>
                
                {selectedProduct.ingredients && (
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2 text-sm">Ingredients:</h4>
                    <div className="grid grid-cols-2 gap-2">
                      {selectedProduct.ingredients.map((ingredient, idx) => (
                        <div key={idx} className="text-xs text-gray-600 bg-gray-50 px-2 py-1 rounded">
                          {ingredient}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                {selectedProduct.washes && (
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-2">
                      <Droplets className="w-4 h-4 text-blue-600" />
                      <span className="text-xs font-medium">{selectedProduct.washes} washes</span>
                    </div>
                    {selectedProduct.loadType && (
                      <div className="flex items-center space-x-2">
                        <Zap className="w-4 h-4 text-orange-600" />
                        <span className="text-xs font-medium">{selectedProduct.loadType}</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
} 